"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SpinButton", {
    enumerable: true,
    get: function() {
        return SpinButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSpinButton = require("./useSpinButton");
const _renderSpinButton = require("./renderSpinButton");
const _useSpinButtonStylesstyles = require("./useSpinButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const SpinButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSpinButton.useSpinButton_unstable)(props, ref);
    (0, _useSpinButtonStylesstyles.useSpinButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useSpinButtonStyles_unstable')(state);
    return (0, _renderSpinButton.renderSpinButton_unstable)(state);
});
SpinButton.displayName = 'SpinButton';
